// Class dates go to the API as 'yyyy-MM-dd' to avoid time zone shifts.

export function toClassDateString(date: Date | string): string {
  if (!date)
    return null;
  const d = date instanceof Date ? date : new Date(date);
  const pad = (n: number) => (n < 10 ? '0' : '') + n;
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}

export function parseClassDate(value: string | Date): Date {
  if (!value)
    return null;
  if (value instanceof Date)
    return value;
  const parts = value.substring(0, 10).split('-').map(x => parseInt(x, 10));
  return new Date(parts[0], parts[1] - 1, parts[2]);
}

export function classSaveErrorMessage(error: any): string {
  let body = error && error.error;
  if (typeof body === 'string') {
    try { body = JSON.parse(body); } catch (e) { return body; }
  }
  return (body && (body.Message || body.message)) || 'The class could not be saved.';
}
